import { makeAutoObservable, runInAction } from 'mobx';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

class PermissionStore {
  userPermissions = {}; // { userId: { read: true, write: false, ... } }
  loading = false;
  user = null;
  auth = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Set data for headers
  setUser(user) {
    this.user = user;
  }

  setAuth(auth) {
    this.auth = auth;
  }

  // Getter for headers
  get headers() {
    return {
      'X-Bitrix-User': this.user,
      'X-Bitrix-Auth': this.auth,
      'Content-Type': 'application/json',
    };
  }

  async fetchUserPermissions(userId) {
    this.loading = true;
    try {
      const response = await axios.get(`${API_URL}/permissions/${userId}`, { headers: this.headers });
      runInAction(() => {
        this.userPermissions[userId] = response.data;
        this.loading = false;
      });
    } catch (e) {
      runInAction(() => { this.loading = false; });
      console.error('Ошибка при загрузке прав пользователя:', e);
      throw e;
    }
  }

  async saveUserPermissions(userId, permissions) {
    this.loading = true;
    try {
      const response = await axios.post(`${API_URL}/permissions/${userId}`, permissions, { headers: this.headers });
      runInAction(() => {
        this.userPermissions[userId] = permissions;
        this.loading = false;
      });
      return response.data;
    } catch (e) {
      runInAction(() => { this.loading = false; });
      console.error('Ошибка при сохранении прав пользователя:', e);
      throw e;
    }
  }

  getPermissions(userId) {
    return this.userPermissions[userId] || {};
  }
}

export default new PermissionStore();
